<div class="corner-left"></div>
<div class="corner-right"></div>
<section class="related-entries container">
  <h3>You may also like&hellip;</h3>
  <div class="entries-grid" *ngIf="entries?.length; else noResults">
    <app-entry-card *ngFor="let e of entries" [entry]="e" [entryClass]="'related'" (open)="open($event)"></app-entry-card>
  </div>
  <ng-template #noResults>
    <p class="no-results">No related entries yet<br /> (based on your search & filter criteria).</p>
  </ng-template>
  <a class="return-home textlink" [href]="'/blog'" [attr.data-content]="'Blog Related Entries Return Home'" (click)="analyticsService.trackInput($event);">Return to blog home</a>
</section>
